module.exports = __webpack_public_path__ + "img/InCopyright-rightsholder.aa0b5995.png";